<template>
  <div class="index">
    <div class="container banner unpage_top">
      <div class='page_width flex'>
        <div class="banner_left">
          <div class="left_title " v-animate="'animate__animated animate__slideInUp'">Streamlined Payments with Minglepay Fast, Secure, and Modern</div>
          <div class="left_text" v-animate="'animate__animated animate__slideInDown'">Effortless Transactions, Maximum Value</div>
          <div class="left_msg " v-animate="'animate__animated animate__slideInUp'">Simplify your payment process with Minglepay. Harness the power of open banking to deliver instant, cost-effective, and seamless payment solutions tailored for today's businesses.</div>
          <!-- <div class="left_text" v-animate="'animate__animated animate__fadeInDown'">Plunge into captivating gameplay, unravel thrilling mysteries, and savor uninterrupted excitement like never before.</div> -->
          <!-- <div class="left_bottom " v-animate="'animate__animated animate__fadeInDown'">
            <span class="bg_btn pointer color1 " @click="toPage('contact-us')">
              <span class="">Contact us</span>
              <i class="arrow"><img src="../../assets/image/arrow_right.png" alt=""></i>
            </span>
          </div> -->
        </div>    
      
      </div>
    </div>


    <div class="container">
      <div class=" page_width">
        <div class="page_thumb">
          <div class="cate_container">
             <div class="grid grid_xs_gap grid_gap_none " >
              <div class="grid_md_6 grid_xs_12 grid_sm_12 ">
                <div class="item_group">
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container half_container_bg" >
                        <img src="../../assets/image/t1.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
              <div class="grid_md_6 grid_xs_12 grid_sm_12">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half flex_col_sb h-100p">
                      <div class="half_container flex_col_sb h-100p" >
                        <div class="half_box half_container_bg">
                          <div class="half_box_icon"><img src="../../assets/image/tb1.png" alt=""></div>
                          <div class="half_box_title mt-20">Card Payments</div>
                          <div class="half_box_msg">Accept payments quickly and securely from customers worldwide. Our open banking-powered system ensures low fees, high success rates, and instant settlements.</div>
                        </div>
                         <div class="half_box half_container_bg mt-20">
                          <div class="half_box_icon"><img src="../../assets/image/tb2.png" alt=""></div>
                          <div class="half_box_title mt-20">Card Payouts</div>
                          <div class="half_box_msg">Disburse funds effortlessly to vendors, partners, or customers with a secure, reliable, and fast payout solution designed to simplify your operations.</div>
                        </div>
                        
                        </div>     
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="page_title_bag pt-60 pb-60" >
        <div class="page_width " >
          <div class="page_title ">
            <div class="title_name">Discover Minglepay</div>
            <div class="title_tag">Minglepay is your all-in-one payment platform, designed to make accepting card payments and managing payouts straightforward, secure, and budget-friendly. Built for businesses of all sizes, Minglepay empowers you with tools to optimize transactions and elevate custome</div>
          </div>
        </div>
      </div>
    </div>


     <div class="container "> 
      <div class="page_width page_top ">
        <div class="page_title" >
          <!-- <div class="title_tag">our team</div> -->
          <div class="title_name color2">What Our Customers Say</div>
        </div>
        <div class="page_thumb ">
          <div class="page_container cate_container"> 
                <div class="grid grid_md_gap grid_xs_gap ">
                 <div class="grid_md_6 grid_xs_12 grid_sm_12 " v-for="(item,index) in clientList" :key="index">
                    <div class="item_group h-100p">
                      <div class="item_inner h-100p">
                        <div class="client_contnet px-30 py-20 border-primary h-100p flex_col_start bg_9">
                          <div class="client_title fs-20 color3 text-l">{{ item.title }}</div>
                          <div class="client_msg mt-20 color6 fw-400">{{ item.msg }}</div>
                          <div class="flex client_box w-100p ">
                              <div class="box_img">
                                <img :src="item.icon" alt="">
                              </div>
                              <div class="box_flex flex_center_start">
                                <div class="box_text">{{ item.text }}</div>
                              </div>
                              <img src="../../assets/picture/syh.png" alt="" style="width: 90px;">
                          </div>
                        </div>
                      </div>
                    </div>
                 </div>
               </div>
          </div>
        </div>   
      </div>
    </div>

    <div class="container  "> 
      <div class="container_full page_top py-50" >
        <div class="page_width " >
          <div class="page_title ">
            <div class="title_name">Effortless Integration for Smarter Payments</div>
            <div class="title_tag mt-30">Launch your payment system in hours, not weeks, with Minglepay's seamless API and front-end components. Integrate effortlessly into your platform and offer your customers a smoother, faster checkout experience from day one.</div>
          </div>
           <div class="cate_container mt-40">
             <div class="grid grid_xs_gap grid_gap_none " >
              <div class="grid_md_5 grid_xs_12 grid_sm_12">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half flex_col_sb h-100p w-100p">
                      <div class="half_container h-100p flex_col_start w-100p" >
                         <div class="half_title color1">Above 90%</div>
                         <div class="half_title color1 mb-20">acceptance rate </div>
                         <div class="half_text flex_center_start ">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Secure and reliable gateway
                         </div>
                         <div class="half_text flex_center_start ">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">All types of tech platforms supported
                         </div>
                         <div class="half_text flex_center_start ">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Easy API key management
                         </div>  
                        </div>   
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_md_7 grid_xs_12 grid_sm_12 ">
                <div class="item_group">
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container" >
                        <img src="../../assets/image/t2.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
      
        <!-- <div class="page_thumb page_bg_1">
          <div class="page_width">
             <div class="page_container cate_container"> 
            <div class="grid grid_xs_gap grid_gap_none ">
              <div class="grid_md_6 grid_xs_12 grid_sm_12">
                <div class="item_group" >
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container" >
                        <div class="half_title">Why Reliable Payment Gateways Matter</div>
                        <div class="half_msg">Traverse the cosmos and steel yourself for epic clashes.</div>
                        <div class="half_text">In the competitive landscape of online betting, trust is everything. Users expect flawless, secure, and swift transactions. Any delay or security lapse can drive customers to competitors. PayPulse ensures high-speed processing and ironclad security, fostering confidence and retaining users for your betting platform.</div>
                      </div>
                   
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_center">
                <div class="item_group">
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container">
                        <div class="half_title">High-Risk Environments. Security First</div>
                        <div class="half_msg">Traverse the cosmos and steel yourself for epic clashes.</div>
                        <div class="half_text">Sports betting is classified as a high-risk industry due to large transaction volumes and potential fraud risks. PayPulse counters these challenges with a state-of-the-art fraud detection system, real-time transaction monitoring, and compliance with PCI DSS standards. Our two-factor authentication and regular system updates safeguard your platform and users' data, ensuring smooth operations even during peak betting events.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        
          </div>
         
        </div> -->
    </div>
    <div class="container  "> 
      <div class=" page_top py-50" >
        <div class="page_width " >
          <div class="page_title ">
            <div class="title_name color4">Flexible Plans for Every Business</div>
            <div class="title_tag mt-30 color6">Unlock cost-effective payments with Minglepay's tailored pricing plans, designed to scale with your needs.</div>
          </div>
           <div class="cate_container">
             <div class="grid grid_xs_gap grid_gap_none " >
              <div class="grid_md_12 grid_xs_12 grid_sm_12">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half flex_col_sb h-100p w-100p border-primary bg_9 p-r">
                      <div class="half_container h-100p flex_col_start w-100p p-30" >
                         <div class="half_title color2">Perfect for Businesses Big and Small</div>
                         <div class="half_msg mb-20 color6">Enjoy secure, instant card payments and payouts with Minglepay's business-friendly plan: </div>
                         <div class="half_text flex_center_start color6">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Free for the first three months for small and medium businesses
                         </div>
                         <div class="half_text flex_center_start color6">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Instant fund access for seamless cash flow
                         </div>
                         <div class="half_text flex_center_start color6">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">Near-zero fraud risk with advanced security measures
                         </div>  
                         <div class="half_text flex_center_start color6">
                          <img src="../../assets/image/g.png" alt="" class="w-30px h-30px mr-30">90%+ transaction success rate for reliable payments
                         </div> 
                         <div class="half_msg mt-40 color6">Contact our sales team for a customized pricing plan that fits your business.</div>
                        </div>   
                        <div class="p-a half_p_img  hidden-sm-and-down"><img src="../../assets/image/t3.png" alt=""></div>
                    </div>
                  </div>
                </div>
              </div>
               
            </div>
          </div>
        </div>
      </div>
      <div class="page_thumb page_bg_2 py-60">
        <div class="page_width">
            <div class="page_title ">
              <div class="title_name color1">Extensive Worldwide Coverage</div>
              <div class="title_tag color1">Unlock our worldwide coverage, ensuring a high acceptance ratio in every corner of the world</div>
            </div>
          <div class="page_container cate_container"> 
            <div class="grid grid_xs_gap grid_gap_none ">
              <div class="grid_md_12 grid_xs_12 grid_sm_12">
                <div class="item_group" >
                  <div class="item_inner">
                    <div class="group_half flex_warp ju_center ">
                        <img :src="i" alt="" class="w-a h-60px p-5" v-for="(i,index) in qbLList" :key="index">
                    </div>
                    <div class="mt-30">
                      <img src="../../assets/image/dt1.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        
        </div>
         
      </div>
    </div>


    <div class="container">
      <div class="page_width mt-80">
        <div class="page_title ">
            <div class="title_name color4">Core Payment Solutions</div>
            <div class="title_tag mt-0 color6">Power your business with Minglepay's streamlined payment tools:</div>
        </div>
        <div class="page_thumb">
          <div class="cate_container">
             <div class="grid grid_xs_gap grid_gap_none " >
              <div class="grid_md_6 grid_xs_12 grid_sm_12 ">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half  h-100p">
                      <div class="half_container flex_col_sb h-100p" >
                       
                         <div class="half_box half_container_bg">
                          <div class="half_box_icon"><img src="../../assets/image/tb1.png" alt=""></div>
                          <div class="half_box_title mt-20">Card Payments</div>
                          <div class="half_box_msg">Accept payments quickly and securely from customers worldwide. Our open banking-powered system ensures low fees, high success rates, and instant settlements.</div>
                        </div>
                        
                        </div>     
                    </div>
                  </div>
                </div>
              </div> 
              <div class="grid_md_6 grid_xs_12 grid_sm_12">
                <div class="item_group h-100p" >
                  <div class="item_inner h-100p">
                    <div class="group_half flex_col_sb h-100p">
                      <div class="half_container  h-100p" >
                        
                         <div class="half_box half_container_bg ">
                          <div class="half_box_icon"><img src="../../assets/image/tb2.png" alt=""></div>
                          <div class="half_box_title mt-20">Card Payouts</div>
                          <div class="half_box_msg">Disburse funds effortlessly to vendors, partners, or customers with a secure, reliable, and fast payout solution designed to simplify your operations.</div>
                        </div>
                        
                        </div>     
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  

 



  
  


    <!-- <div class="container "> 
      <div class="page_width page_top ">
          <div class="page_thumb ">
          <div class="page_container cate_container"> 
                <div class="grid grid_gap_none ">
                 <div class="grid_md_7 grid_xs_12 grid_sm_12 " >
                    <div class="build_group ">
                      <div class="build_title color2 text_left">FAQ</div>
                      <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How does PayPulse support fast payments?" name="1">
                            <div class="coll_item">PayPulse integrates with global fast payment systems, enabling instant transfers for B2B, B2C, and P2P transactions.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="What are the benefits of fast payment systems?" name="2">
                           <div class="coll_item">Instant transfers, low/no fees, and support for cross-bank transactions enhance user convenience and platform efficiency.</div>
                          </el-collapse-item>
                        
                        </el-collapse>
                      </div>
                     
                    </div>
                 </div>
                <div class="grid_md_5 grid_xs_12 grid_sm_12 " >
                    <div class="build_group">
                      <img src="../../assets/picture/faq.png" alt="">
                    </div>
                 </div>
               </div>
             
    
          </div>
        </div> 
        
      </div>
    </div> -->
  
  </div>

</template>

<script>
import { swiper, swiperSlide,} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import rw1 from '../../assets/picture/tx1.png'
import rw2 from '../../assets/picture/tx2.png'
import rw3 from '../../assets/picture/tx3.png'
import rw4 from '../../assets/picture/tx4.png'


import qb1 from '../../assets/image/qb1.png'
import qb2 from '../../assets/image/qb2.png'
import qb3 from '../../assets/image/qb3.png'
import qb4 from '../../assets/image/qb4.png'
import qb5 from '../../assets/image/qb5.png'
import qb6 from '../../assets/image/qb6.png'
import qb7 from '../../assets/image/qb7.png'
import qb8 from '../../assets/image/qb8.png'
import qb9 from '../../assets/image/qb9.png'
import qb10 from '../../assets/image/qb10.png'
import qb11 from '../../assets/image/qb11.png'
import qb12 from '../../assets/image/qb12.png'
import qb13 from '../../assets/image/qb13.png'
import qb14 from '../../assets/image/qb14.png'
import qb15 from '../../assets/image/qb15.png'
import qb16 from '../../assets/image/qb16.png'
import qb17 from '../../assets/image/qb17.png'
import qb18 from '../../assets/image/qb18.png'
import qb19 from '../../assets/image/qb19.png'
import qb20 from '../../assets/image/qb20.png'
import qb21 from '../../assets/image/qb21.png'
import qb22 from '../../assets/image/qb22.png'
import qb23 from '../../assets/image/qb23.png'
import qb24 from '../../assets/image/qb24.png'
import qb25 from '../../assets/image/qb25.png'

export default {
  components: {
    swiper,
    swiperSlide, 
  },
  data () {
    return {
      tabId:'1',
      screenWidth: document.body.clientWidth,
      swiperOption: {},
      swiperOption2: {},
      gameList:[],
      loadFlag:false,
     
       options:[
          {value:'up to 1 million',label:'up to 1 million'},
          
      ],
      clientList:[
        {id:1,icon:rw1,msg:"Switching to Minglepay's card payment system has transformed our operations at ZoomRide. We've slashed processing costs by 85% and receive funds instantly. This efficiency lets us prioritize delivering top-tier car-sharing services. Minglepay's support is unmatched — a true partner in our success!',text:'ZoomRide Team',title:'Revolutionizing Transactions for Growth",},
        {id:2,icon:rw2,msg:"Minglepay's card payment solutions have streamlined our checkout process, saving time and reducing costs. Their intuitive platform and dedicated support have opened new avenues for scaling our business. It's like having an extra team member!',text:'EcoShop Owners',title:'A Partner for Progress",},
        {id:3,icon:rw3,msg:"Integrating Minglepay's card payment system into our online store was a breeze. Transactions are lightning-fast, secure, and reliable, which is critical in the fast-paced tech retail market. Their responsive support team ensures we're always on track. Minglepay has elevated our customer experience to new heights.',text:'TechTrend Innovations',title:'Speed and Security in Every Transaction",},
        {id:4,icon:rw4,msg:"Minglepay's card payout system has simplified how we handle payments for our travel services. It's secure, transparent, and aligns perfectly with our mission to deliver exceptional customer experiences. We couldn't ask for a better payment partner!',text:'WanderEasy Travel',title:'Travel Payments, Redefined",},
      ],
      qbLList:[qb1,qb2,qb3,qb4,qb5,qb6,qb7,qb8,qb9,qb10,qb11,qb12,qb13,qb14,qb15,qb16,qb17,qb18,qb19,qb20,qb21,qb22,qb23,qb24,qb25,],
      subjict:'up to 1 million',
      activeName:'1',
    }
  },
  created () {
    this.setOptions()
    this.setOptions2()
    this.getGames()
  },
  methods: {
    setOptions(){
      this.swiperOption = {
        loop: false,
        autoplay: false,
        slidesPerView:3.4,
        centeredSlides : false,
        spaceBetween: 50,
        // freeMode: true,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
          el:'.swiper-pagination',
          clickable:true
        },
        breakpoints: { 
          //当宽度小于等于320
          767: {
            slidesPerView: 1.2,
          },
          
        },
      }
   
    },
    setOptions2(){
      this.swiperOption2 = {
        loop: false,
        autoplay: false,
        // slidesPerView:1,
        // centeredSlides : false,
        spaceBetween: 0,
        // freeMode: true,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
          el:'.swiper-pagination2',
          clickable:true
        },
       
      }
   
    },
    toPage(item){
     
      this.$router.push('/'+item)

      
    },

    windowScroll() {
    // 滚动条距离页面顶部的距离
    // 以下写法原生兼容
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(scrollTop > 0){
      this.$store.state.isFloat = true
    }else{
      this.$store.state.isFloat = false
    }

    },
    getGames(){

     let games =  this.$store.state.games 
     let gameList=games.slice(0,3)
     this.gameList = gameList
    }
  

    
    
  },
  mounted () {
    window.onresize = () => {
      this.screenWidth = window.innerWidth
    },
    window.addEventListener('scroll', this.windowScroll);
    
  },
  computed:{
   
    mySwiper(){
      return this.$refs.mySwiper.swiper
    },
    mySwiper(){
      return this.$refs.mySwiper.swiper2
    },
    joinList(){ return this.$store.state.joinList },
    games(){ return this.$store.state.games }
  },
  watch: {
    // "$store.state.page": {
    //   handler: function (newVal) {
    //     this.name = newVal
    
    //   }
    // },
    
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScroll);
  },


  
}
</script>
<style lang='scss' scoped>
.index {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color:#fff;
  
  .banner{
    display: flex;
    background-image:url(../../../public/bg/bn_bg.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    height: 800px;
    .banner_left{
      width:100%;
      // transform: translateX(-50%);
      color:$theme_color1;

      margin-top:220px;
      .left_title{
        font-size: 60px;
        font-weight: bold;
        line-height: 1.2;
      }
      .left_msg{
        font-family: PingFang SC, PingFang SC;
        font-size: 20px;
        line-height: 1.4;
        margin-top:20px;
        font-weight: 300;
      }
      .left_bottom{
        
        font-size: 20px;
        margin-top:30px;
        >span{
          padding:6px 20px;
        }
        .arrow{
          display: inline-block;
          width: 14px;
          margin-left:8px;
          position: relative;
          top:2px;
        }
        
      }
      .left_text{
        font-size: 30px;
        margin-top:50px;
        line-height: 1.2;
        padding-right:60px;
      
      }
    }
    .banner_right{
      width: 55%;
    }
    
  }
  .page_top{
    margin-top:80px;
  }
 
  .item_group{
   
    .item_inner{
      position: relative;
      
    }
    .group_half{
      padding:10px;
      .min_title{
          color:$theme_color3;
          font-size:40px;
          margin-bottom:10px;
          text-align: left;
        }
    
      .btn_more{
        color: $theme_color3;
        font-size: 20px;
        text-decoration-line: underline;
        margin-top:10px;
      }
      .half_container{
        
        text-align: left;
        margin-bottom:20px;
        
        .half_title{
          font-size: 40px;
          color:$theme_color3;
        }
        .half_msg{
          font-size: 20px;
         
          
          // font-family: PingFang SC, PingFang SC;;
        }
        .half_text{
          font-size: 16px;
          color:$theme_color1;
          font-family: PingFang SC, PingFang SC;
          margin-top:20px;
        }
        &:last-child{
          margin-bottom: 0;
        }
        .half_box{
          
          .half_box_icon{
            width: 60px;
            height: 60px;
          }
          .half_box_title{
            font-size: 30px;
            line-height: 2;
            color:$theme_color5;
            
          }
          .half_box_msg{
            font-size: 16px;
            font-family: PingFang SC, PingFang SC;
            color:$theme_color6;
            font-weight: 400;
          }
        }
      }
      .half_container_bg{
        padding: 20px;
        background: #F7F9FC;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #DEE6FC;
      }
      .half_p_img{
        max-width:480px;
        width: 40%;
        max-height: 480px;
        right:0;
        bottom:-80px;

      }
      
      
    }
    .client_contnet{
     
      .client_msg{
        font-family: PingFang SC, PingFang SC;
        font-size: 16px;
        text-align: left;
      }
      .client_box{
        margin-top:30px;
        .box_img{
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
        }
        .box_flex{

          flex: 1;
          text-align: left;
          margin-left:20px;
          .box_name{
            font-size:24px;
            color:$theme_color3;
          }
          .box_text{
            font-size: 20px;
            color:$theme_color2;
          }
        }
      }
    } 
    .thumb_wrap{
      
      .half_wrap{
        position: relative;
        text-align: left;
        background:$theme_color2;
        border-radius: 10px;
        // padding:40px 40px;
        margin-bottom:20px;
        // min-height: 400px;
        position: relative;
        padding:20px 10px;
        overflow: hidden;
        .wrap_img{
          width:50px;
          height: 50px;
         >img{
          width: 100%;
          height: 100%;
         }
        }
        .wrap_info{
          margin-left:20px;
          flex:1;
          padding-right:40px;
          .wrap_title{
            color:$theme_color1;
            font-size: 20px;
            line-height: 1;
            text-align: left;
          }
          .wrap_text{
            color:$theme_color1;
            font-size: 14px;
            margin-top:10px;
            font-family: PingFang SC, PingFang SC;
            
          }
        }
       
        .text_bottom{
          position: absolute;
          width: 150px;
          bottom:-14px;
          color:$theme_color4;
          left:50%;
          transform: translateX(-50%);
          >span{
            padding:4px 0;
          }
        }
      }
    }
   
    
  }
  .swiper_pagination,.swiper_pagination2{
        position: relative;
        top:20px;
      }

  
 .more{
  padding:10px 20px;
  display: inline-block;
 }
 .games_container{
  grid-column-gap:20px;
  overflow: hidden;
  transition: all 0.25s ease;

 }
 .loadMore{
  height: auto;
  overflow: visible;
 }
  
  
 .page_bg_2{
     background-image:url(../../../public/bg/bg_2.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
 }
 
  .build_group{
    .build_title{
      font-size: 50px;

    }
    .build_msg{
      font-size: 20px;
      margin-top:10px;
      font-weight: 100;
      font-family: PingFang SC, PingFang SC;
    }
    .build_img{
      width:220px;
      height: 220px;
      border-radius: 50%;
      overflow: hidden;
      margin-top:20px;
    }
    .build_tag{
      font-size: 20px;
      font-weight: 500;
      margin-top:20px;
    }
    
    .faq_collapse{
      margin-top:20px;
      .el-collapse{
        border-top:none;
        .coll_item{
          color:$theme_color2;
          font-size: 16px;
          text-align: left;
          font-family: PingFang SC, PingFang SC;
          padding: 10px 20px;
        }
      }
      /deep/ .el-collapse-item__header{
          height: 80px;
          font-size: 26px;
          text-align: left;
          border-bottom:4px solid #344F67;
        }
        /deep/ .el-collapse-item__header.is-active{
          color:$theme_color3;
        }
    }
  }


}
</style>
<style lang="scss">

.swiper-pagination-bullet-active{
  background: $theme_color3 !important;
  width: 80px!important;
}
.el-step__icon-inner{
 color:$theme_color1;
  
}
.el-step__line-inner{
  border-width:2px!important;
}
.el-step.is-horizontal .el-step__line{
  height: 4px;
}
.el-step__icon.is-text{
 background:$theme_color4;
 border-color:$theme_color4;
}
.el-step__head.is-finish{
  color:$theme_color3;
  border-color:$theme_color3;
  .el-step__icon-inner{
  //  color:$theme_color3;

  }
  .el-step__icon.is-text{
  background:$theme_color3;
  border-color:$theme_color3;
  }
} 
 


</style>